import React from "react";
import styles from "../boatInfo.module.css";
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

function EditButton({ mode, option, el, cardStatus, handle, action }) {
  const access = useChapterActionIdMatch(action);
  return (
    <>
      {mode === "edit" && option.editTable && access && (
        <td>
          {(!el.hasOwnProperty("isActiv") || el?.isActiv) && (
            <div
              // className={`${styles["edit-buttons"]} btn btn-primary `}
              className={styles["delete-button-block"]}
              data-event={option.eventKey}
              data-rowid={el.id}
              id={option.keyTable}
              onClick={(e) => handle(e, el, option.keyTable)}>
              <span
                className={`${option.eventKey === "edit" ? styles["edit-button"] : styles["delete-button"]}`}
                onClick={(e) => handle(e, el, option.keyTable)}></span>
            </div>
          )}
        </td>
      )}
    </>
  );
}

export default EditButton;
